export class CanvasBaseComponent {
    constructor(props) {
        /**
         * Dependencies that the visual state of the component depends on. If during a
         * re-render these change the dependencyUpdateHandlers will be invoked.
         */
        this.dependencies = [];
        this.nextDependencies = [];
        /** Pixi handlers to invoke when props change */
        this.propUpdateHandlers = [];
        this.props = props;
    }
    isChanged(props) {
        const deps = this.getDependencies(props);
        this.nextDependencies = deps;
        return deps.some(([depProps], index) => depProps.some((prop, depPropIndex) => prop !== this.dependencies[index][0][depPropIndex]));
    }
    redraw(props) {
        const changedDepHandlers = this.nextDependencies.reduce((acc, [depProps, depHandlers], index) => {
            const isChanged = depProps.some((prop, depPropIndex) => prop !== this.dependencies[index][0][depPropIndex]);
            if (isChanged) {
                acc.push(...depHandlers);
            }
            return acc;
        }, []);
        this.updateProps(props);
        changedDepHandlers.forEach((handler) => handler(props));
    }
    updateProps(props) {
        this.props = props;
        this.dependencies = this.getDependencies(props);
        this.propUpdateHandlers.forEach((handler) => handler(props));
    }
    /* Method which should be implemented by consumer that returns dependencies that the component depends on */
    getDependencies(_) {
        return [];
    }
    /* Set or update handlers which should be invoked whenever any props change */
    setPropUpdateHandlers(updateHandlers) {
        this.propUpdateHandlers = updateHandlers;
    }
}
